import React from "react";
import ErrorPage from '../../components/ErrorPage'
import { Alert } from "reactstrap";
import Cotizacion1 from "../../components/CotizacionPymes/CotizacionPymes";
import Cotizacion02 from "../../components/CotizacionPymes/CotizacionPymes02";
import Cotizacion2 from "../../components/CotizacionPymes/CotizacionPymes2";
import Cotizacion3 from "../../components/CotizacionPymes/CotizacionPymes3";
import Cotizacion4 from "../../components/CotizacionPymes/CotizacionPymes4";
import Resumen from "../../components/CotizacionPymes/Resumen";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { ProvinciasPymesFetch, FetchMaxCoberturas, FetchGirosNegocios, CoberturasPymesFetch } from '../../redux/actions/aRamoPymes'
import { sucursalesFetch } from "../../redux/actions/aRamos";
import { urlCiudadesPymes, urlCrearCotizacionPymes, plataforma1 as plataforma, emp as empresa, ambienteAplicacion, urlRecuperarCotizacionPymes, urlResumenPymes, urlEditarUbicacionPymes, urlEditarCotizacionPymes, urlEditarCoberturasPymes } from '../../constants/urls'
import Page from "../../components/Page";
import { apiPost, apiGet } from '../../api'
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
//import {encriptarTramaAES} from '../../utils/Encriptar'

class ContainerCotizacionPymes extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: '', paso: 1, arrayCoberturas: [], arrayUbicaciones: [], ubSelec: 0, ubicaciones: 1, alert: '', Allciudades: [], ciudades: [], loading: true, arrayDatosContratante: '', codGiroNegocio: '', arraySiniestralidad: [], step: 1, sucursalAsesor: this.props.datosAsesor.sucursalCodCore ? this.props.datosAsesor.sucursalCodCore : "001", volverResumen: false, volverResumenUbicacion: false, generalesValues: null, deshabilitar: false, correoEnviado: false, urlPdf: '',  cargarRecargo: false }
    this.props.ProvinciasPymesFetch()
    this.props.FetchGirosNegocios();
    this.props.fethSucursales();
  }

  componentDidMount = async () => {

    const param = new URLSearchParams(this.props.location.search);
    let id = param.get('id');
    if (id) {
      id = id.replace('?id=', '')
      await this.consultarCotizador(id, '', '')
    }

    if (this.props.coberturas && (this.props.coberturas.length > 0) && this.state.codGiroNegocio) {
      this.consultarMaximosCoberturas()
    } else {
      this.setState({ loading: false })

      console.log('this.props.coberturas ', this.state.codGiroNegocio)
    }



  }
  consultarMaximosCoberturas = async (codCobertura) => {
    this.handleLoading(true)
    console.log('vv', this.state)
    const { codGiroNegocio, idCarrito } = this.state;
    if (!codCobertura && this.props.coberturas) codCobertura = this.props.coberturas[0].codigo
    if (!codGiroNegocio) {
      this.handleLoading(false)
      return
    }


    await this.props.FetchMaxCoberturas({ giroNegocio: codGiroNegocio, codCobertura, idCarrito })

    this.handleLoading(false)
  }


  consultarCoberturas = async () => {

    const { codGiroNegocio, idCarrito } = this.state;
    if (!codGiroNegocio) {
      this.handleLoading(false)
      return
    }

    await this.props.CoberturasPymesFetch({ giroNegocio: codGiroNegocio })

    this.handleLoading(false)

  }
  handleLoading(loading) {
    this.setState({ loading })
  }

  consultarCotizador = async (id, editar, regresaResumen) => {
    const { volverResumen } = this.state
    let url = urlRecuperarCotizacionPymes
    if (editar === 'ubicacion') {
      url = urlEditarUbicacionPymes
      this.props.ProvinciasPymesFetch()
    }
    if (editar === 'anadirUbicacion') {
      url = urlEditarCotizacionPymes
      this.props.ProvinciasPymesFetch()
    }
    else if (editar === 'cotizacion') {
      url = urlEditarCotizacionPymes
    }
    else if (editar === 'cobertura') {
      url = urlEditarCoberturasPymes
    }
    const res = await apiGet(url + id)

    if (res.codGiroNegocio) {
      await this.props.CoberturasPymesFetch({ giroNegocio: res.codGiroNegocio })
    }

    if (res.carRecotizacion) {
      this.setState({ deshabilitar: true })
    } else {
      this.setState({ deshabilitar: false })
    }


    if (res.carUrlPdf) {
      this.setState({ carUrlPdf: res.carUrlPdf })
    }


    if (res.carCorreoRecotizacionEnviado == null || res.carCorreoRecotizacionEnviado == false) {
      this.setState({ correoEnviado: false })
    } else {
      this.setState({ correoEnviado: true })
    }

    console.log('ressss', res)

    if (res.generales) {
      this.setState({ generalesValues: res.generales })
    }


    this.setState({ volverResumen: editar === 'anadirUbicacion' ? false : res.resumen ? true : false })
    if (editar === 'anadirUbicacion') {
      this.setState({ volverResumenUbicacion: true })
    } else {
      if (editar != 'anadirUbicacion') {
        this.setState({ volverResumenUbicacion: false })
      }
    }

    const { transaccion, errorDescripcion, arrayCoberturas } = res
    if (transaccion) {
      let { search } = this.props.location
      const param = new URLSearchParams(search);
      let paso = parseInt(param.get('paso'));
      paso = paso ? paso : res.paso
      //validar que viene de facturacion
      let backfacturacion = param.get('back')
      if (backfacturacion && backfacturacion !== "" && backfacturacion !== null && backfacturacion !== undefined) {
        paso = backfacturacion
      }
      if (regresaResumen !== '') {
        paso = regresaResumen
        this.setState({ resumen: res.resumen })
      }
      //Validar el paso si son ediciones      
      if (editar !== '' && editar === 'ubicacion') {
        paso = 2;
      }
      if (editar !== '' && editar === 'anadirUbicacion') {
        paso = 1;
      }
      else if (editar !== '' && editar === 'cotizacion') {
        this.setState({ volverResumen: true })
        paso = 5;
      }
      else if (editar !== '' && editar === 'cobertura') {
        //this.setState({volverResumen:true})   
        paso = 3;
      }
      else if (editar !== '' && editar === 'resumen') {
        this.setState({ volverResumen: true })
        paso = 'resumen';
      }
      if (paso === 7 || paso === '7') {
        //Agregado para el resumen cuando se recupera la cotizacion
        this.props.history.replace({
          pathname: '/datos-facturacion',
          search: `id=${id}`,
        })
      }
      else {
        //Funciona correctamente
        this.props.history.replace({
          pathname: '/pymes/cotizador',
          search: `paso=${paso}&id=${id}`,
        })
      }

      let arrayUbicaciones = res.arrayUbicaciones
      if (!arrayUbicaciones) {
        arrayUbicaciones = this.creararrayUbicaciones(res.numUbicaciones)
      }
      if (res.giroNegocio && res.giroNegocio !== undefined && res.giroNegocio !== '') {
        this.setState({ codGiroNegocio: res.giroNegocio })
      }
      await this.consultarMaximosCoberturas('incendioAliadas')
      let arraySiniestralidad = res.generales ? res.generales.siniestralidad : ''

      if (!arraySiniestralidad)
        arraySiniestralidad = this.state.arraySiniestralidad
      this.setState({ ...res, idCarrito: id, ubicaciones: res.numUbicaciones, arrayUbicaciones, arraySiniestralidad, paso })
    }
    else {
      this.setState({ error: errorDescripcion || true })
    }

  }

  creararrayUbicaciones = ubicaciones => {
    let { arrayUbicaciones } = this.state
    if (arrayUbicaciones.length < ubicaciones)
      for (let i = (arrayUbicaciones.length); i < ubicaciones; i++) {
        arrayUbicaciones.push('');
      }
    else if (arrayUbicaciones.length > ubicaciones) {
      arrayUbicaciones = arrayUbicaciones.slice(0, ubicaciones)
    }
    return arrayUbicaciones
  }
  handleResumen = async () => {

    const url = urlResumenPymes + this.state.idCarrito
    try {

      let res = await apiGet(url)
      if (res.transaccion) {
        this.setState({ resumen: { ...res }, step: 2 })
        this.consultarCotizador(this.state.idCarrito, 'resumen', '')
        // this.props.history.replace({
        //   pathname: '/pymes/cotizador',
        //   search: `paso=resumen&id=${this.state.idCarrito}`,
        // })        
      }
      else {
        this.setState({ alert: res.errorDescripcion })
        setTimeout(() => {
          this.setState({ alert: '' })
        }, 5000);
      }
      window.scroll(0, 0)

    } catch (error) {

    }
  }
  handleNext = async ({ arraySiniestralidad, ubicaciones, codGiroNegocio, arrayDatosContratante, arrayCoberturas, adicional, sucursalAsesor }) => {
    let { paso } = this.state
    this.toggleLoading()
    let guardar = {}

    if (paso === 1) {
      //Crear Nodo carDatosAsesor      
      let arrayDatosAsesor = {
        nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
        codigoCore: this.props.datosAsesor.cliCodigoCore,
        sucursalSeleccionada: sucursalAsesor,
        ambiente: ambienteAplicacion,
        emailAsesor: this.props.datosAsesor.correo ? this.props.datosAsesor.correo : '',
        brokerRUC: this.props.datosAsesor.brokerRUC ? this.props.datosAsesor.brokerRUC : '',
        brokerNombre: this.props.datosAsesor.brokerNombre ? this.props.datosAsesor.brokerNombre : '',
        brokerCodigo: this.props.datosAsesor.brokerCodigo ? this.props.datosAsesor.brokerCodigo : '',
      }
      const r = await this.guardarPasos({ codGiroNegocio, numUbicaciones: ubicaciones, arrayDatosContratante, paso, adicional, arrayDatosAsesor })
      if (r) {
        if (this.props.dataPymes.hasError)
          this.setState({ alert: this.props.dataPymes.hasError })

        const arrayUbicaciones = this.creararrayUbicaciones(ubicaciones)
        guardar = { ubicaciones, codGiroNegocio, arrayUbicaciones, ubSelec: 0, arrayDatosContratante }
      }
    } else if (paso === 4) {
      const r = await this.guardarPasos({ arraySiniestralidad })
      guardar = { arraySiniestralidad }
    } else if (paso === 3) {




      await this.consultarMaximosCoberturas()
      if (this.props.dataPymes.maxCoberturas.length <= 0) return
      const r = await this.guardarPasos({ arrayCoberturas, paso: 4 })
      guardar = { arrayCoberturas }
    }
    window.scroll(0, 0)

    this.setState({ loading: false, ...guardar })
  }
  toggleLoading = () => this.setState((prevState) => ({ ...prevState, loading: !prevState.loading }))

  handleBack = () => {
    const { ubSelec, paso } = this.state;
    if (paso === 2 && ubSelec > 0) {
      return this.setState({ ubSelec: ubSelec - 1 })
    }
    const param = new URLSearchParams(this.props.location.search);
    let id = param.get('id');

    this.props.history.push({
      pathname: '/pymes/cotizador',
      search: `paso=${paso - 1}&id=${id}`,
    })

  }

  getCiudades = async (idProv) => {

    this.setState({ loading: true })
    const { Allciudades } = this.state
    if (idProv === '') {
      const { provincias } = this.props.dataPymes
      idProv = provincias[0].id
    }
    const encuentra = Allciudades.find(({ id }) => id === idProv)
    if (!encuentra) {
      try {
        const { transaccion, ciudades } = await fetch(urlCiudadesPymes + idProv).then(response => response.json())
        if (transaccion && ciudades && ciudades.length > 0) {
          let data = []
          ciudades.forEach(({ ciuNombre: name, id, provCodigo, provNombre }) => data.push({ id, name, provCodigo, provNombre }));
          Allciudades.push({ id: idProv, ciudades: data })
          this.setState({ loading: false, Allciudades, ciudades: data })
        } else {
          this.setState({ loading: false, alert: 'Error buscando ciudades, seleccione otra ciudad' });
        }

      } catch (error) {
        this.setState({ loading: false, alert: 'Error consultando ciudades' });
      }
    } else {
      const { ciudades } = encuentra
      this.setState({ loading: false, ciudades })
    }
  }
  guardarPasos = async ({ arraySiniestralidad, codGiroNegocio, numUbicaciones, arrayDatosContratante, arrayCoberturas, adicional, arrayDatosAsesor }) => {

    const { cliCodigoCore } = this.props
    const { paso, idCarrito: id } = this.state
    const param = {
      empresa,
      plataforma,
      paso,
      cliCodigoCore,
      codGiroNegocio,
      numUbicaciones,
      arrayDatosContratante,
      idCarrito: id,
      arrayCoberturas,
      ambiente: ambienteAplicacion,
      adicional,
      arraySiniestralidad,
      arrayDatosAsesor
    }
    const { transaccion, idCarrito, errorDescripcion } = await apiPost(urlCrearCotizacionPymes, param)

    if (transaccion) {
      if (paso === 1) this.setState({ idCarrito: idCarrito ? idCarrito : id, adicional });
      this.props.history.push({
        pathname: '/pymes/cotizador',
        search: `paso=${paso + 1}&id=${this.state.idCarrito}`,
      })
      return true
    } else {
      alert(errorDescripcion)
    }
    return false
  }

  guardarUbicacion = async (data, i, regresarResumen) => {
    let { arrayUbicaciones, idCarrito } = this.state
    const ubicacionesAnteriores = [...arrayUbicaciones]

    arrayUbicaciones[i] = data
    ubicacionesAnteriores[i] = { ...ubicacionesAnteriores[i], ...data }
    let ubSelec = 0
    let siguiente = ''

    for (let i = 0; i < arrayUbicaciones.length; i++) {
      const data = arrayUbicaciones[i];

      if (!data) {
        siguiente = i;
        ubSelec = i
        break
      }
    }

    const arrayUbi = arrayUbicaciones.filter((data) => (data !== ''));

    const { cliCodigoCore } = this.props

    const param = { empresa, plataforma, paso: 2, cliCodigoCore, arrayUbicaciones: arrayUbi, idCarrito, resumen: regresarResumen || this.state.volverResumenUbicacion, ubicacionesAnteriores: ubicacionesAnteriores, ubicacionActual: i }
    const res = await apiPost(urlCrearCotizacionPymes, param)

    if (res.transaccion) {
      if (!siguiente && siguiente !== 0) {
        this.setState({ arrayUbicaciones: ubicacionesAnteriores })
        if (regresarResumen && regresarResumen === true) {
          this.consultarCotizador(this.state.idCarrito, '', 'resumen')
        }
        else {
          this.props.history.push({
            pathname: '/pymes/cotizador',
            search: `paso=${3}&id=${this.state.idCarrito}`,
          })
        }

      }
      else this.setState({ arrayUbicaciones: ubicacionesAnteriores, ubSelec })
    } else alert(res.errorDescripcion)

    window.scrollTo(0, 0)

  }
  componentDidUpdate(prevProps, prevState) {
    const { ubSelec, arrayUbicaciones } = this.state
    if (ubSelec !== prevState.ubSelec && arrayUbicaciones[ubSelec]) {
      this.getCiudades(arrayUbicaciones[ubSelec].provincia ? arrayUbicaciones[ubSelec].provincia : '')
    }

    if (this.props.coberturas && prevProps.coberturas !== this.props.coberturas) {

      this.consultarMaximosCoberturas();
    }
    let { search } = this.props.location
    if (search !== prevProps.location.search) {
      const param = new URLSearchParams(search);
      let paso = parseInt(param.get('paso'));
      let id = (param.get('id'));
      if (isNaN(paso)) paso = param.get('paso')
      this.setState({ paso, idCarrito: id })
    }
  }

  redireccionarFacturacion = () => {
    this.props.history.push({
      pathname: "/datos-facturacion",
      search: `?id=${this.state.idCarrito}`
    });
  }

  editarValoresUbicacion = () => {
    let id = this.state.idCarrito
    this.consultarCotizador(id, 'ubicacion', '')
  }

  editarValoresCotizacion = () => {
    this.consultarCotizador(this.state.idCarrito, 'cotizacion', '')
  }

  editarCoberturas = () => {
    this.consultarCotizador(this.state.idCarrito, 'cobertura', '')
  }

  anadirUbicacion = () => {
    this.consultarCotizador(this.state.idCarrito, 'anadirUbicacion', '')
  }

  render() {
    if (this.state.error)
      return <ErrorPage mainText={this.state.error} />
    const { maxCoberturas } = this.props
    let arraySucursales = [];
    this.props.sucursales.map(s => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    });

    const { pathname } = this.props.location
    const { paso, arrayUbicaciones, ubSelec, ubicaciones, codGiroNegocio, alert, Allciudades, ciudades, loading, arrayDatosContratante, arrayCoberturas, pymesCampoAdicional, arraySiniestralidad, step, sucursalAsesor, volverResumen } = this.state
    console.log("fff", maxCoberturas)
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <LoadingScreen
              loading={loading || this.props.dataPymes.isLoading || this.props.isLoadingPersoneria || this.state.cargarRecargo}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Cargando..."
            >

              <Page title="Cotización Pymes" breadcrumbs={[{ name: "Cotización Pymes", active: true }]} >
                <div>
                  <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', }} >
                    <div className="wrapper-step" >
                      <div className="arrow-steps clearfix-step">
                        <div className={step === 1 ? "step current" : "step"}> {` 1. Cotización `} </div>
                        <div className={step === 2 ? "step current" : "step"}> {` 2. Resumen `} </div>
                        <div className={step === 3 ? "step current" : "step"}> {` 3. Confirmación `} </div>
                        <div class="step"> {` 4. Forma de Pago `} </div>
                        <div class="step"> {` 5. Formulario de Vinculación `} </div>
                        <div class="step"> {` 6. Emisión `} </div>
                      </div>
                    </div>
                  </div>

                  {alert && <Alert color="danger">{` ${alert}, recargue la página o intente nuevamente `}</Alert>}

                  {paso === 1 && <Cotizacion1 handleNext={this.handleNext} ubicaciones={ubicaciones} codGiroNegocio={codGiroNegocio} arrayDatosContratante={arrayDatosContratante} adicional={pymesCampoAdicional} arraySucursales={arraySucursales} datosAsesor={this.props.datosAsesor} sucursalAsesor={sucursalAsesor} />}

                  {paso === 2 && <div className='container-body-spaces' style={{ marginTop: 10, }} >
                    <div className='flex container-body-spaces' style={{ flexWrap: 'wrap', }}> {arrayUbicaciones.map((data, i) => {
                      let clase = 'botontabs'
                      if (!data && ubSelec !== i) clase = `${clase} disabledAll`
                      if (ubSelec === i) clase = `botontabsSelected ${clase}`

                      return <div key={'botonesUbicacion' + i} className={clase} onClick={() => !data ? console.log('') : this.setState({ ubSelec: i })} > {` Ubicación ${i + 1}`} </div>
                    }
                    )}
                    </div>
                  </div>
                  }
                  {paso === 2 && arrayUbicaciones.map((data, i) => <div key={`ubicacion${i}`} className={ubSelec === i ? '' : 'divUbicacion'}>
                    < Cotizacion2 key={'Cotizaciones' + i}
                      data={data}
                      NumUbicacion={i + 1}
                      handleNext={this.handleNext}
                      Allciudades={Allciudades}
                      ciudades={ciudades}
                      getCiudades={this.getCiudades}
                      guardarUbicacion={this.guardarUbicacion}
                      handleBack={this.handleBack}
                      volverResumen={volverResumen}
                    /> </div>)
                  }
                  {paso === 3 &&
                    <Cotizacion3
                      handleNext={this.handleNext}
                      handleBack={this.handleBack}
                      coberturas={this.props.coberturas}
                      arrayCoberturas={arrayCoberturas}
                      fetchMaximos={this.consultarMaximosCoberturas} />
                  }
                  {paso === 4 && arrayCoberturas.length > 0 &&
                    <Cotizacion02 handleNext={this.handleNext} handleBack={this.handleBack} arraySiniestralidad={arraySiniestralidad} arrayCoberturas={arrayCoberturas} />
                  }
                  {paso === 5 && Object.keys(maxCoberturas).length > 0 &&
                    <Cotizacion4
                      handleNext={this.handleNext}
                      generalesValues={this.state.generalesValues}
                      handleBack={this.handleBack}
                      handleResumen={this.handleResumen}
                      codGiroNegocio={codGiroNegocio}
                      arrayCoberturas={arrayCoberturas}
                      arrayUbicaciones={arrayUbicaciones}
                      idCarrito={this.state.idCarrito}
                      fetchMaximos={this.consultarMaximosCoberturas}
                      volverResumen={volverResumen}
                    />
                  }
                  {`${paso}` === 'resumen' && this.state.resumen &&
                    <Resumen
                      resumen={this.state.resumen}
                      idCarrito={this.state.idCarrito}
                      redireccionar={this.redireccionarFacturacion}
                      editarUbicacion={this.editarValoresUbicacion}
                      editarCotizacion={this.editarValoresCotizacion}
                      editarCoberturas={this.editarCoberturas}
                      anadirUbicacion={this.anadirUbicacion}
                      deshabilitar={this.state.deshabilitar}
                      carUrlPdf={this.state.carUrlPdf}
                      correoEnviado={this.state.correoEnviado}
                      setCorreoEnviado={(value) => {
                        this.setState({ correoEnviado: value })
                      }}
                      setCargarRecargo={(value) => {
                        this.setState({ cargarRecargo: value })
                      }}
                    />
                  }
                </div>
              </Page>
            </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  dataPymes: state.dataPymes,
  coberturas: state.dataPymes.coberturas,
  maxCoberturas: state.dataPymes.maxCoberturas,
  cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore,
  isLoadingPersoneria: state.catalogosCotizacion.personeria.isLoading,
  dataUsuario: state.datosUsuarios,
  datosAsesor: state.datosUsuarios.dataUsuario,
  sucursales: state.datosSucursales.DataSucursales,
});

const mapDispatchToProps = dispatch => {
  return {
    ProvinciasPymesFetch: () => dispatch(ProvinciasPymesFetch()),
    FetchGirosNegocios: () => dispatch(FetchGirosNegocios()),
    FetchMaxCoberturas: (data) => dispatch(FetchMaxCoberturas(data)),
    CoberturasPymesFetch: (data) => dispatch(CoberturasPymesFetch(data)),
    fethSucursales: () => dispatch(sucursalesFetch()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionPymes)
);